export default "__VITE_ASSET__Cecp0tnr__"